import React from "react";
import ScheduleCalendar from "./ScheduleCalendar";
export default React.memo(ScheduleCalendar);
